module.exports = __webpack_public_path__ + "img/ic_content_copy.876fdb95.svg";